import { useQuery } from '@tanstack/react-query'
import { movesKeys } from '@/api/queryKeys'
import { fetchMoves } from '@/api/moves'

/**
 * Hook to fetch all moves with optional filters
 *
 * @param params - Query parameters for filtering
 * @returns React Query result with moves list data
 *
 * @example
 * ```tsx
 * const { data, isLoading, error } = useMoves({ searchText: 'armbar', limit: 20 });
 * ```
 */
export function useMoves(params?: {
  searchText?: string
  limit?: number
  offset?: number
  includeRelations?: boolean
}) {
  return useQuery({
    queryKey: movesKeys.list(params ?? {}),
    queryFn: () => fetchMoves(params ?? {}),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
